import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAdminUsersQuery, useClientByIdQuery } from '../../../api';
import { ManagementRoleMapping, ManagerModel } from '../../../models/Manager';

export const useManagement = () => {
  const [modalState, setModalState] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data: clientDetails = {} } = useClientByIdQuery({ id });
  const { data: userData = [] } = useAdminUsersQuery();

  const onAddModalStateChange = useCallback(() => setModalState((prevState) => !prevState), []);

  const managementData = useMemo(() => {
    const management: Record<string, ManagerModel> = {};
    userData.forEach((user: ManagerModel) => {
      management[user.id] = user;
    });
    return [
      {
        role: ManagementRoleMapping.salesManager,
        data: management[clientDetails.salesManagerId],
      },
      {
        role: ManagementRoleMapping.salesManagerAssistant,
        data: management[clientDetails.salesManagerAssistantId],
      },
      {
        role: ManagementRoleMapping.purchaseManager,
        data: management[clientDetails.purchaseManagerId],
      },
      {
        role: ManagementRoleMapping.purchaseManagerAssistant,
        data: management[clientDetails.purchaseManagerAssistantId],
      },
    ];
  }, [userData, clientDetails]);
  return {
    modalState,
    onAddModalStateChange,
    clientDetails,
    managementData,
  };
};
